import {VehicleFinancingInterestRateTypeSchema} from '@dms/api/sales';

/**
 * Reads an interest rate type from a picker value. An unknown value yields `null`, so the field
 * falls back to the template instead of persisting an unsupported type.
 */
export function parseInterestRateType(value: string | null) {
  const result = VehicleFinancingInterestRateTypeSchema.safeParse(value);

  return result.success ? result.data : null;
}
